@if (state.isActive()) {
  <div id="map-wall-display-overlay" [class.workbench-mode]="state.isMapInWorkbenchMode()">
    @if (state.isMapInWorkbenchMode()) {
      <topo-wall-display-widget-config />
    }

    <div class="widget-container">
      @if (state.showTimesWidget()) {
        <div [class.has-divider-bottom]="state.showLocationsWidget()">
          <topo-time-cards-widget />
        </div>
      }

      @if (state.showLocationsWidget()) {
        <topo-location-cards-widget />
      }

      <section>
        <div [style.flex]="1">
          @if (state.showWorkflowStatusWidget()) {
            <topo-alert-status-counts-widget />
          }
        </div>

        @if (state.showAlertFeedWidget()) {
          <topo-alert-feed-widget
            [style.maxWidth.vh]="50"
            [style.height.%]="100" />
        }
      </section>

      @if (state.showMapLegendWidget()) {
        <topo-map-legend-widget [style.zIndex]="3" />
      }

      @if (state.showImageCardWidget()) {
        <topo-image-card-widget [style.zIndex]="10" />
      }
    </div>
  </div>
}
